import { useEffect, useRef } from "react";
import useSaveScrollPosition from "utils/hooks/SaveScrollPosition";
import { CustomComponentProps } from "utils/types/general.types";

export type FixedScrollContainerProps = CustomComponentProps & {
    sessionName: string;
    children: React.ReactNode;
};

const FixedScrollContainer = ({
    sessionName,
    children,
    className,
    style
}: FixedScrollContainerProps) => {
    const feedRef = useRef<HTMLDivElement>(null);
    useSaveScrollPosition(feedRef, sessionName);

    useEffect(() => {
        const savedScrollPosition = sessionStorage.getItem(sessionName);
        if (savedScrollPosition && feedRef.current) {
            feedRef.current.scrollTo(0, parseInt(savedScrollPosition, 10));
        }
    }, []);
    return (
        <div
            className={`w-full h-full flex relative overflow-auto ${className}`}
            ref={feedRef}
            style={style}
        >
            {children}
        </div>
    );
};

export default FixedScrollContainer;
